<template>
 <div class="ui centered grid">
    <div class="three wide column"></div>
    <div class="ten wide column">
        <div class="ten wide column">
            <div  class="ui hidden message" style="margin-bottom:25px;" v-bind:class="{'positive':messageType=='positive','negative':messageType=='negative'}" id="message">
                <i class="close icon" v-on:click="hideMessage()"></i>
                <div class="header" style="padding-left:30px">{{message}}</div>
            </div>
            <div v-if="!loading">
                <div class="ui top attached tabular menu">
                    <a class="active item" data-tab="">Users</a>
                    <!--  <av-on:click="activateTab(item.number)" class="item" data-tab="" v-bind:class="{'active':activeTab==item.number}">Search Logs</a>-->
                    <div class="right menu">
                        <i class="large user plus icon" v-on:click="openBlankUserForm()" style="cursor:pointer"></i>
                    </div>
                </div>
                <div class="ui active bottom attached tab segment" data-tab="">
                    <TheUserList v-if="!userFormOpened" v-bind:usersList="usersList" @editUser="loadUserData" @deleteUser="deleteUser"></TheUserList>
                    <TheUserForm v-if="userFormOpened" v-bind:blank="blank" @formClose="closeUserForm" v-bind:userData="userData"></TheUserForm>
                </div>
                <div class="ui mini modal" id="deleteConfirm">
                    <div class="content">
                        <p>Delete the user {{user_msg}}</p>
                    </div>
                    <div class="actions">
                        <div class="ui red cancel inverted button">
                            <i class="remove icon"></i> No
                        </div>
                        <div class="ui green ok inverted button">
                            <i class="checkmark icon"></i> Yes
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="three wide column"></div>
</div>

</template>

<script>
  import TheUserList from '../components/TheUserList.vue'
  import TheUserForm from '../components/TheUserForm.vue'
  export default {
    name: 'list',
    components: {
      TheUserList,
      TheUserForm
    },
    data() {
      return {
        message: "This message",
        messageType: "negative",
        usersList: null,
        loading: true,
        userFormOpened: false,
        blank: true,
        user_msg: "",
        userData: {
          uuid: "",
          username: "",
          first_name: "",
          last_name: "",
          email: "",
          role: "",
        }
      }
    },


    methods: {
      showMessage: function(messageType, message) {
        this.message = message;
        this.messageType = messageType;
        $('#message').transition('fade up');
      },
      hideMessage: function(s) {
        setTimeout(function() {
          $('#message').transition('fade up');
        }, s * 1000);

        // this.messageVisible = false;
      },

      deleteUser: function(uuid) {
        var myThis = this;
        $('#deleteConfirm').modal({
          onApprove: function() {
            axios
              .delete('/api/user/' + uuid)
              .then(response => {
                if (response.status == 200) {
                  myThis.showMessage('positive', "User deleted succesfully.");
                  myThis.hideMessage(5);
                }
                else {
                  myThis.showMessage('negative', "Cannot delete user. Server response: " + response.status);
                }
                myThis.loadData(false);
              });
          }
        }).modal('show');
      },

      loadData: function(loading) {
        this.loading = loading;
        axios
          .get('/api/users')
          .then(response => {
            this.usersList = response.data;
            this.loading = false;
          });
      },

      loadUserData: function(uuid) {
        axios
          .get('/api/user/' + uuid)
          .then(response => {
            this.userData = response.data;
            this.userFormOpened = true;
            this.blank = false;
          });
      },

      openBlankUserForm: function() {
        this.blank = true;
        this.userData = {
          uuid: "",
          username: "",
          first_name: "",
          last_name: "",
          email: "",
          role: "",
        }
        this.userFormOpened = true;
      },

      closeUserForm: function(status) {
        if (status == 201) {
          if (this.blank) {
            this.showMessage('positive', "User created succesfully.");
          }
          else {
            this.showMessage('positive', "User updated succesfully.");
          }
          this.loadData(false);
          this.userFormOpened = false;
          this.hideMessage(5);
        }
        else if (status == 0) {
          this.loadData(false);
          this.userFormOpened = false;
        }
        else {
          this.showMessage('negative', "Cannot create user. Server response: " + status);
        }

      }
    },

    mounted() {
      this.loadData(true);

    },

    watch: {
      $route(to, from) {
        this.loadData();
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/admin.vue